import React, { ImgHTMLAttributes } from 'react';

// Current the process of fetching the image from cloudfront is failing. After the security issues
// are resolved, we can work on fixing this.
export default function CachedImage({ src, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={src} {...props} />;
}
